import * as React from 'react';

import { PageSeoInfo } from 'components';
import { useCategoryAction, useCategoryValue } from 'context';

const CategorySeoInfo = () => {
  const { title, seo, ownerType } = useCategoryValue();
  const action = useCategoryAction();

  return (
    <PageSeoInfo
      seo={seo}
      ownerType={ownerType}
      defaultName={title}
      onUpdateSeoInfo={result => {
        action({
          type: 'UPDATE_CATEGORY_SEO',
          payload: {
            seo: result,
          },
        });
      }}
    />
  );
};

export { CategorySeoInfo };
